var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1921.757,
    height: 1205.643,
    viewBox: "0 0 1921.757 1205.643",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: -0.241,
    x2: 0.791,
    y2: 1.214,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#14204a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "black"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M398,566.389s60.728,430.643,510.094,201.279S2318.847-4.591,2318.847-4.591l-.574-366.1L397.09-370.12Z",
    transform: "translate(-397.09 370.694)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderShape);
export default __webpack_public_path__ + "static/media/header_shape.16731439276597d576622feb8bbfc924.svg";
export { ForwardRef as ReactComponent };